import React from "react";
import { useNavigate } from "react-router-dom";
const Empty = ({ content }) => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "20px",
        height: "90vh",
        width: "100%",
        
      }}
    >
      <div style={{ fontSize: "20px", fontWeight: "bold" , textAlign: "center", color: "#898787" }}>{content}</div>
      <button className="my-btn" onClick={() => navigate(-1)}>Go back</button>
    </div>
  );
};

export default Empty;
